module.exports = __webpack_public_path__ + "img/1578109636.5ed9ede7.jpg";